import React from 'react';
import '../../css/CourseProgressBox.css';

function CourseProgressBox({ chapters }) {
    const getSections = (chapter) => (chapter.sections || []).filter(item => item.type === "section");
    const getBonuses = (chapter) => (chapter.sections || []).filter(item => item.type === "bonus");

    const totalSections = chapters.reduce((acc, chapter) => acc + getSections(chapter).length, 0);
    const completedSections = chapters.reduce((acc, chapter) => {
        return acc + getSections(chapter).filter(s => s.completed).length;
    }, 0);
    const sectionProgress = totalSections > 0 ? (completedSections / totalSections) * 100 : 0;

    const totalExercises = chapters.reduce((acc, chapter) => acc + getBonuses(chapter).length, 0);
    const completedExercises = chapters.reduce((acc, chapter) => {
        return acc + getBonuses(chapter).filter(b => b.claimed).length;
    }, 0);
    const exerciseProgress = totalExercises > 0 ? (completedExercises / totalExercises) * 100 : 0;

    return (
        <div className="course-progress-box">
            <h3>Course Progress</h3>
            <div className="progress-row">
                <span className="progress-icon"><i className="bi bi-book"></i></span>
                <span>Total Sections</span>
                <span className="progress-count">{completedSections} / {totalSections}</span>
            </div>
            <div className="progress-bar">
                <div className="progress-fill" style={{ width: `${sectionProgress}%` }}></div>
            </div>
            {/*
            <div className="progress-row">
                <span className="progress-icon"><i className="bi bi-award"></i></span>
                <span>Checkpoints</span>
                <span className="progress-count">{completedExercises} / {totalExercises}</span>
            </div>
            <div className="progress-bar">
                <div className="progress-fill" style={{ width: `${exerciseProgress}%` }}></div>
            </div>
            */}
        </div>
    );
}

export default CourseProgressBox;